import styled, { css } from "styled-components";

import { pxToRem } from "../../styles/utils";

const ChoiceControl = styled.input`
  appearance: none;
  display: grid;
  place-content: center;
  flex: 0 0 auto;
  width: ${pxToRem(20)};
  height: ${pxToRem(20)};
  margin: 0;
  border: ${pxToRem(1.5)} solid ${({ theme }) => theme.colors.graySlate};
  border-radius: ${({ type, theme }) => type === "radio" ? pxToRem(theme.radii.pill) : pxToRem(theme.radii.sm)};
  background: ${({ theme }) => theme.colors.white};
  cursor: pointer;
  transition: border-color 0.15s ease, background-color 0.15s ease;

  &::before {
    content: "";
    width: ${pxToRem(10)};
    height: ${pxToRem(10)};
    background: ${({ theme }) => theme.colors.brand};
    transform: scale(0);
    transition: transform 0.1s ease;

    ${({ type, theme }) => type === "radio" ? css`
      border-radius: ${pxToRem(theme.radii.pill)};
    ` : css`
      width: ${pxToRem(11)};
      height: ${pxToRem(11)};
      clip-path: polygon(14% 44%, 0 60%, 40% 100%, 100% 22%, 84% 8%, 38% 68%);
      background: ${theme.colors.white};
    `}
  }

  &:checked {
    border-color: ${({ theme }) => theme.colors.brand};
    background: ${({ type, theme }) => type === "checkbox" ? theme.colors.brand : theme.colors.white};
  }

  &:checked::before {
    transform: scale(1);
  }

  &:hover:not(:disabled) {
    border-color: ${({ theme }) => theme.colors.brandStrong};
  }

  &:focus-visible {
    outline: ${pxToRem(2)} solid ${({ theme }) => theme.colors.brand};
    outline-offset: ${pxToRem(2)};
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export default ChoiceControl;
